import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'

import { getAddress } from '../utils'

const usePosition = () => {
  const [coords, setCoords] = useState({
    lat: null,
    lng: null,
  })
  const [error, setError] = useState(null)

  /**
   * @param {{ coords: GeolocationCoordinates }} position
   */
  const onChange = ({ coords }) => {
    setCoords({
      lat: coords.latitude,
      lng: coords.longitude,
    })
  }

  /**
   * @param {GeolocationPositionError} error
   */
  const onError = (error) => {
    setError(error.message)
  }

  useEffect(() => {
    const geo = navigator.geolocation
    if (!geo) {
      setError('Geolocation is not supported')
      return
    }

    const watcher = geo.watchPosition(onChange, onError)

    return () => geo.clearWatch(watcher)
  }, [])

  const { data: addressData } = useQuery(
    ['address', coords.lat, coords.lng],
    () => getAddress(coords.lat, coords.lng),
    {
      initialData: {
        address: '',
        postalCode: null,
        lat: null,
        lng: null,
      },
      enabled: Boolean(coords.lat) && Boolean(coords.lng),
    }
  )

  // console.log(':: browser address data?', addressData)

  return {
    ...addressData,
    error,
  }
}

export default usePosition
